import {
  pubNotice,
  userLogin,
  userPasswordNoLogin,
  userLogout,
  userInfo,
  userList,
  userAdd,
  userEdit,
  userPassword,
  userFindPassword,
  userDelete,
  userSuggest,
} from '@/api/user'
import { removeToken } from '@/utils/auth'

export default {
  async pubNotice({ }, data) {
    return pubNotice(data)
  },
  // 登录
  async userLogin({ }, data) {
    return userLogin(data)
  },
  async userPasswordNoLogin({ }, data) {
    return userPasswordNoLogin(data)
  },
  async userLogout({ commit }, data) {
    await userLogout();
    removeToken()
    commit('SET_NAME', '')
    commit('SET_ROLE', '')
    commit('SET_USER_INFO', null)
    return {
      code: 0
    }
  },
  async userInfo({ commit }, data) {
    const ret = await userInfo(data)
    if (ret.code === 0 && ret.data) {
      const { name, role, last_name, first_name } = ret.data
      commit('SET_NAME', name)
      let full_name = name;
      if (last_name) {
        full_name = `${first_name} ${last_name}`;
        commit('SET_NAME_EN', full_name);
        ret.data.full_name = full_name;
      }
      commit('SET_ROLE', role)
      commit('SET_USER_INFO', ret.data)
    }
    return ret
  },
  async userList({ }, data) {
    return userList(data)
  },
  async userAdd({ }, data) {
    return userAdd(data)
  },
  async userEdit({ }, data) {
    return userEdit(data)
  },
  async userPassword({ }, data) {
    return userPassword(data)
  },
  async userFindPassword({ }, data) {
    return userFindPassword(data)
  },
  async userDelete({ }, data) {
    return userDelete(data)
  },
  async userSuggest({ }, data) {
    return userSuggest(data)
  },
}
